<template>
	<div class="infor fl">
		<AllHeader :label="lable" :ischage="ischage" :sublabel="sublabel" :subtitle="subtitle" :year="year"
			@getvalue="getvalue" />
		<div v-if="step == 0">
                    <el-form ref="queryForm" size="small" :inline="true" label-width="68px" style="margin-top:20px;text-align:left;">
                        <el-form-item label="年份批次" prop="searchYear">
                            <el-select style="width: 200px" v-model="searchYear" placeholder="评选年份批次" clearable>
                                <el-option key="" label="请选择" value="" />
                                <el-option v-if="batches" v-for="(item,key) in batches" :key="item.id" :label="item.year+'-'+item.batch" :value="item.id"></el-option>
                               <!-- <el-option key="2021" label="2020-2021" value="2021" />
                                <el-option key="2022" label="2021-2022" value="2022" />
                                <el-option key="2023" label="2022-2023" value="2023" />
                                <el-option key="2024" label="2023-2024" value="2024" /> -->
                            </el-select>
                        </el-form-item>
                        <el-form-item label="审核状态" prop="searchYear">
                            <el-select style="width: 200px" v-model="searchstatus" placeholder="状态" clearable v-if="award_id != 17">
                                <el-option key="1" label="待分配专家" value="1" />
                                <el-option key="2" label="待专家审核" value="2" />
                                <el-option key="3" label="待平台审核" value="3" />
                                <el-option key="4" label="审核通过" value="4" />
                                <el-option key="5" label="审核不通过" value="5" />
                                <el-option key="6" label="已分配专家" value="6" />
                            </el-select>
                            <el-select style="width: 200px" v-model="searchstatus" placeholder="状态" clearable v-else>
                                <el-option key="1" label="待分配专家" value="1" />
                                <el-option key="2" label="待专家审核" value="2" />
                                <el-option key="3" label="待平台审核" value="3" />
                                <el-option key="5" label="审核不通过" value="5" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="申报单位" prop="keyword">
                            <el-input style="width: 200px"
                                      v-model="keyword"
                                placeholder="请输入申报单位名称"
                                clearable/>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
                            <el-button type="success" icon="el-icon-download" size="mini" @click="downloadClick(1)">申报汇总表导出</el-button>
                            <el-button type="success" icon="el-icon-download" size="mini" @click="downloadClick(2)">申报登记表导出</el-button>
                        </el-form-item>
                    </el-form>
			<el-table :data="formlist"
                      v-loading="loading"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%; margin-top: 10px" :cell-style="{'text-align':'center'}">
				<el-table-column prop="no" label="序号" min-width="75"></el-table-column>
				<el-table-column prop="year" label="年度批次" min-width="100"></el-table-column>
				<el-table-column v-if="!isGroupAward" prop="content.Contractorinfo.projectNname" label="申报工程名称" show-overflow-tooltip
					min-width="120"></el-table-column>
				<el-table-column v-else prop="content.project_title" label="课题名称" show-overflow-tooltip
					min-width="120"></el-table-column>
				<el-table-column prop="user.name" label="申报单位" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column v-if="award_id == 9" prop="content.Contractorinfo.name31" label="申报联系人" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column v-if="award_id == 9" prop="content.Contractorinfo.movephone11" label="联系电话" show-overflow-tooltip min-width="120"></el-table-column>
				<el-table-column min-width="360" label="审核">
					<template slot-scope="scope">
						<el-button v-if="scope.row.status==1||scope.row.status==2||scope.row.status==3" size="mini" @click="handleDelete(scope.$index, scope.row)"
							style="background: #F53B3B;border-radius: 4px 4px 4px 4px;color: white;"
							icon="el-icon-close">驳回</el-button>
						<el-button v-if="scope.row.status==1||scope.row.status==2||scope.row.status==3" size="mini" type="success" icon="el-icon-check"
							@click="handleEdit(scope.$index, scope.row)">通过</el-button>
                            <el-button v-if="scope.row.status==1" @click="getapply(scope.row)" size="mini"
                            	style="color: #FAA24B;border-radius: 4px 4px 4px 4px;border: 1px solid #FAA24B;">分配专家
                            </el-button>
                            <el-button v-if="scope.row.status==5" @click="viewRejectReason(scope.row)" size="mini"
                            	style="color: #808895;border-radius: 4px 4px 4px 4px;border: 1px solid #808895;">驳回理由
                            </el-button>
                            <el-button v-if="scope.row.status==2" @click="getapply(scope.row, { reAssign: true })" size="mini"
                            	style="color: #808895;border-radius: 4px 4px 4px 4px;border: 1px solid #808895;">重新分配
                            </el-button>
                            <el-button @click="toDetail(scope.row)" size="mini"
                            	style="color: #808895;border-radius: 4px 4px 4px 4px;border: 1px solid #808895;">查看材料
                            </el-button>

					</template>
				</el-table-column>
			</el-table>
			<Pagetion :total="total" @getpageValue="getpageValue" class="pos-page" />
            <el-dialog title="导出" :visible.sync="download" width="500px">
                <div class="form_right" style="width:400px">
                    <div class="form_1">
                        <div class="form_box_content">
                            <div class="flex">
                                <div class="my_form2">
                                    <div class="form_title" style="">日期</div>
                                    <div class="form_content">
                                        <el-date-picker
                                            v-model="timeRange"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                        </el-date-picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="exportInfo">导 出</el-button>
                  </span>
            </el-dialog>
		</div>
		<div v-if="step==1">
			<el-table :data="temformlist"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%;" :cell-style="{'text-align':'center'}">
				<el-table-column prop="no" label="序号" min-width="80"></el-table-column>
				<el-table-column prop="year" label="评选年度" min-width="100"></el-table-column>
				<el-table-column prop="content.Contractorinfo.projectNname" label="申报工程名称" show-overflow-tooltip
					min-width="120"></el-table-column>
				<el-table-column prop="user.name" label="申报单位" show-overflow-tooltip min-width="120"></el-table-column>
				<el-table-column v-if="award_id == 9" prop="content.Contractorinfo.name31" label="申报联系人" show-overflow-tooltip min-width="120"></el-table-column>
				<el-table-column v-if="award_id == 9" prop="content.Contractorinfo.movephone11" label="联系电话" show-overflow-tooltip min-width="120"></el-table-column>

                <el-table-column min-width="280" label="审核">
					<template slot-scope="scope">
						<el-button  v-if="scope.row.status==1||scope.row.status==2||scope.row.status==3" size="mini" @click="handleDelete(scope.$index, scope.row)"
							style="background: #F53B3B;border-radius: 4px 4px 4px 4px;color: white;"
							icon="el-icon-close">驳回</el-button>
						<el-button v-if="scope.row.status==1||scope.row.status==2||scope.row.status==3" size="mini" type="success" icon="el-icon-check"
							@click="handleEdit(scope.$index, scope.row)">通过</el-button>
						<el-button  v-if="scope.row.status==1" @click="getapply(scope.row)" size="mini"
							style="color: #FAA24B;border-radius: 4px 4px 4px 4px;border: 1px solid #FAA24B;">分配专家
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			
			
			<el-tabs style="" v-model="activeName" tab-position="top">
				<el-tab-pane label="承建单位(申报单位)简况" name="first">
					<div class="form_right">
					<div class="form_1" id="Contractorinfo">
						<div class="form_box_content">
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">工程名称</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.projectNname}}
									</div>
									<div class="form_title" style="">推荐单位</div>
									<div class="form_long">
										{{parameters.Contractorinfo == undefined ? '' :  parameters.Contractorinfo.RecommendedUnit}}
									</div>
									<div class="form_title" style="">申报单位</div>
									<div class="form_long">
										{{parameters.Contractorinfo == undefined ? '' :  parameters.Contractorinfo.ReportingUnit}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">填报日期</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.Filling_date}}
									</div>
									<div class="form_title" style="">承建单位信息</div>
									<div class="form_long">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.Contractor_name1}}
									</div>
									<div class="form_title" style="">通信地址</div>
									<div class="form_long">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.mailing_address1}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">联系电话</div>
									<div class="form_content">
										<div class="input">
											{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.phone11}}
										</div>
									</div>
									<div class="form_title" style="">邮政编码</div>
									<div class="form_content">
										<div class="input">
											{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.Postal1}}
										</div>
									</div>
									<div class="form_title" ></div>
									<div class="form_content"></div>
								</div>
							</div>
							<div class="flex">
							<div class="my_form2">
								<div class="form_title" style="">
									主营范围及其资质等级
								</div>
								<div class="form_textarea">
									{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.Qualification_level1}}
								</div>
							</div>
							</div>
							<div class="flex">
							<div class="my_form2">
								<div class="form_title" style="">
									承建内容
								</div>
								<div class="form_textarea">
									{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.Construction_content1}}
								</div>
							</div>
							</div>
							<div class="flex">
							<div class="my_form">
								<div class="form_title">
									承建单位简介(500字以内)
								</div>
								<div class="form_textarea">
									{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.brief_introduction1}}
								</div>
							</div>
							</div>
							<div class="form_title">
								<p style="padding-bottom: 20px">法定代表人信息</p>
							</div>
							<div class="flex">
								<div class="my_form">
									<div class="form_title" style="">姓名</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.name21}}
									</div>
									<div class="form_title" style="">联系电话</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.phone21}}
									</div>
									<div class="form_title" ></div>
									<div class="form_content"></div>
								</div>
							</div>
							<div class="form_title">
								<p style="padding-bottom: 20px">申报工作联系人</p>
							</div>
							<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">姓名</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.name31}}
									</div>
									<div class="form_title" style="">工作部门</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.work_department1}}
									</div>
									<div class="form_title" style="">职务</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.postion1}}
									</div>
								</div>
							</div>
							<div class="flex">
								<div class="my_form">
									<div class="form_title" style="">固定电话</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.guding_phone1}}
									</div>
									<div class="form_title" style="">移动电话</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.movephone11}}
									</div>
									<div class="form_title" ></div>
									<div class="form_content"></div>
								</div>
							</div>
							<div class="form_title">
								<p style="padding-bottom: 20px">项目经理</p>
							</div>
							<div class="flex">
								<div class="my_form">
									<div class="form_title" style="">姓名</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.name41}}
									</div>
									<div class="form_title" style="">持证等级</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.leave1}}
									</div>
									<div class="form_title" style="">联系电话</div>
									<div class="form_content">
										{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.phone31}}
									</div>
								</div>
							</div>
						</div>
					</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="参建单位简况" name="second">
					<el-table :data="temUnitlist"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" :cell-style="{'text-align':'center'}">
						<el-table-column prop="" label="序号" min-width="40">
							<template slot-scope="scope">
							     <span v-text="getIndex(scope.$index)"> </span>
							</template>
						</el-table-column>
						<el-table-column prop="unitname" label="参建单位" show-overflow-tooltip min-width="200"></el-table-column>
						<el-table-column min-width="100" label="操作">
							<template slot-scope="scope">
								<el-button @click="toUnitDetail(scope.row)" size="mini"
									style="color: #808895;border-radius: 4px 4px 4px 4px;border: 1px solid #808895;">查看详情
								</el-button>
							</template>
						</el-table-column>
					</el-table>
                    <el-dialog title="参建单位详情信息" :visible.sync="dialogUnitVisible" width="874px" :before-close="handleUnitClose">
                        <div class="form_right">
                            <div class="form_1">
                                <div class="form_box_content">
                                    <div class="flex">
                                        <div class="my_form2">
                                            <div class="form_title" style="">单位名称</div>
                                            <div class="form_content">
                                                {{unit.unitname}}
                                            </div>
                                            <div class="form_title" style="">通信地址</div>
                                            <div class="form_long">
                                                {{unit.phoneaddress}}
                                            </div>
                                            <div class="form_title" style="">邮政编码</div>
                                            <div class="form_long">
                                                {{unit.codeyouzheng}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form2">
                                            <div class="form_title" style="">联系电话</div>
                                            <div class="form_content">
                                                {{unit.Telephone}}
                                            </div>
                                            <div class="form_title" style=""></div>
                                            <div class="form_long">
                                            </div>
                                            <div class="form_title" style=""></div>
                                            <div class="form_long">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form2">
                                            <div class="form_title" style="">
                                                主营范围及其资质等级
                                            </div>
                                            <div class="form_textarea">
                                                {{unit.Qualification_level}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form2">
                                            <div class="form_title" style="">
                                                参建内容
                                            </div>
                                            <div class="form_textarea">
                                                {{unit.Construction_content}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form">
                                            <div class="form_title">
                                                参建工作量
                                            </div>
                                            <div class="form_textarea">
                                                {{unit.Construction_workload}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form2">
                                            <div class="form_title" style="">参建比例</div>
                                            <div class="form_content">
                                                {{unit.Construction_proportion}}
                                            </div>
                                            <div class="form_title" style=""></div>
                                            <div class="form_long">
                                            </div>
                                            <div class="form_title" style=""></div>
                                            <div class="form_long">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form">
                                            <div class="form_title">
                                                参建单位简介(200字以内)
                                            </div>
                                            <div class="form_textarea">
                                                {{unit.brief_introduction}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form_title">
                                        <p style="padding-bottom: 20px">法定代表人信息</p>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form">
                                            <div class="form_title" style="">姓名</div>
                                            <div class="form_content">
                                                {{unit.name2}}
                                            </div>
                                            <div class="form_title" style="">联系电话</div>
                                            <div class="form_content">
                                                {{unit.phone2}}
                                            </div>
                                            <div class="form_title" ></div>
                                            <div class="form_content"></div>
                                        </div>
                                    </div>
                                    <div class="form_title">
                                        <p style="padding-bottom: 20px">申报工作联系人</p>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form2">
                                            <div class="form_title" style="">姓名</div>
                                            <div class="form_content">
                                                {{unit.name3}}
                                            </div>
                                            <div class="form_title" style="">工作部门</div>
                                            <div class="form_content">
                                                {{unit.work_department}}
                                            </div>
                                            <div class="form_title" style="">职务</div>
                                            <div class="form_content">
                                                {{unit.postion}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form">
                                            <div class="form_title" style="">固定电话</div>
                                            <div class="form_content">
                                                {{unit.guding_phone}}
                                            </div>
                                            <div class="form_title" style="">移动电话</div>
                                            <div class="form_content">
                                                {{unit.movephone1}}
                                            </div>
                                            <div class="form_title" ></div>
                                            <div class="form_content"></div>
                                        </div>
                                    </div>
                                    <div class="form_title">
                                        <p style="padding-bottom: 20px">项目经理</p>
                                    </div>
                                    <div class="flex">
                                        <div class="my_form">
                                            <div class="form_title" style="">姓名</div>
                                            <div class="form_content">
                                                {{unit.name4}}
                                            </div>
                                            <div class="form_title" style="">持证等级</div>
                                            <div class="form_content">
                                                {{unit.leave}}
                                            </div>
                                            <div class="form_title" style="">联系电话</div>
                                            <div class="form_content">
                                                {{unit.phone3}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>
				</el-tab-pane>
				<el-tab-pane label="申报工程概况" name="three">
					<div class="form_right">
						<div class="form_1">
							<div class="form_box_content">
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">工程名称</div>
										<div class="form_content">
											{{parameters.Contractorinfo == undefined ? '' : parameters.Contractorinfo.projectNname}}
										</div>
										<div class="form_title" style="">建设地点</div>
										<div class="form_long">
											{{parameters.ProjectOverview.Construction_site}}
										</div>
										<div class="form_title" style="">工程类别</div>
										<div class="form_long">
											{{parameters.ProjectOverview.workscategory}}
										</div>
									</div>
								</div>
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">使用功能</div>
										<div class="form_content">
											{{parameters.ProjectOverview.functi}}
										</div>
										<div class="form_title" style="">建设规模</div>
										<div class="form_long">
											{{parameters.ProjectOverview.build}}
										</div>
										<div class="form_title" style="">结构类型</div>
										<div class="form_long">
											{{parameters.ProjectOverview.structure}}
										</div>
									</div>
								</div>
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">申报范围</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.declare}}
											</div>
										</div>
										<div class="form_title" style="">工程合同额</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.engineering}}
											</div>
										</div>
										<div class="form_title" style="">开工时间</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.worktime}}
											</div>
										</div>
									</div>
								</div>
								<div class="flex">
									<div class="my_form2">
										<!-- <div class="form_title" style="">竣工时间</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.becompleted}}
											</div>
										</div> -->
										<div class="form_title" style="">验收时间</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.acceptance}}
											</div>
										</div>
										<div class="form_title" style="">验收单位</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.acceptance_unit}}
											</div>
										</div>
                                        <div class="form_title" style=""></div>
                                        <div class="form_content">
                                        </div>
									</div>
								</div>
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">勘察单位</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.survey_unit}}
											</div>
										</div>
										<div class="form_title" style="">建设单位</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.Construction_unit}}
											</div>
										</div>
										<div class="form_title" style="">使用单位</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.User_unit}}
											</div>
										</div>
									</div>
								</div>
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">设计单位</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.Design_unit}}
											</div>
										</div>
										<div class="form_title" style="">监理单位</div>
										<div class="form_content">
											<div class="input">
												{{parameters.ProjectOverview.control_unit}}
											</div>
										</div>
										<div class="form_title" style="">质量监督单位</div>
										<div class="form_content">
                                            <div class="input">
                                            	{{parameters.ProjectOverview.pro_control_unit}}
                                            </div>
										</div>
									</div>
								</div>
								<div class="flex">
								<div class="my_form2">
									<div class="form_title" style="">
										工程简介（800字以内）
									</div>
									<div class="form_textarea">
										{{parameters.ProjectOverview.project_info}}
									</div>
								</div>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="申报理由" name="four">
					<div class="form_right">
						<div class="form_1">
							<div class="form_box_content">
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">
											参照申报条件阐述理由
										</div>
										<div class="form_textarea">
											{{parameters.Explain_the_reason}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="有关单位意见" name="five">
					<div class="form_right">
						<div class="form_1">
							<div class="form_box_content">
								<img style="width: 165;height: 108px;margin-top: 54px;" src="../assets/noyijian.png" />
								<div class="spanText">有关单位意见为线下填写内容，请线下查看</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="申报登记表需补充内容" name="sex">
					<el-table :data="temFilelist"
						:header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
						style="width: 100%;" :cell-style="{'text-align':'center'}">
						<el-table-column prop="" label="序号" min-width="40">
							<template slot-scope="scope">
							     <span v-text="getIndex(scope.$index)"> </span>
							</template>
						</el-table-column>
						<el-table-column label="资料名称" show-overflow-tooltip min-width="200">
                            <template slot-scope="scope">
                                <a class="a01" v-if="scope.row.is=='1'&&scope.row.filename!='反映工程概况和质量状况的彩色照片15张'&&scope.row.file&&scope.row.file.response" :href="scope.row.file.response.data.url" target="_blank">{{scope.row.filename}}</a>
                                <a class="a01" @click="dialogTableVisible = true" v-else-if="scope.row.is=='1'&&scope.row.filename=='反映工程概况和质量状况的彩色照片15张'" target="_blank">{{scope.row.filename}}</a>
                                <span v-else >{{scope.row.filename}}</span>
                            </template>
                        </el-table-column>
						<el-table-column min-width="100" label="是否已上传">
							<template slot-scope="scope">
                                <div v-if="scope.row.is=='1'&&scope.row.filename!='反映工程概况和质量状况的彩色照片15张'&&scope.row.file&&scope.row.file.response" style="line-height: 10px;height: 21px;">
                                    <i style="color:#37C8AA;font-size: 20px;vertical-align: middle" class="el-icon-success"></i>
                                    <span class="span02">已上传</span>
                                </div>
                                <div v-else-if="scope.row.is=='1'&&scope.row.filename=='反映工程概况和质量状况的彩色照片15张'" style="line-height: 10px;height: 21px;">
                                    <i style="color:#37C8AA;font-size: 20px;vertical-align: middle" class="el-icon-success"></i>
                                    <span class="span02">已上传</span>
                                </div>
                                <div v-else class="span03">未上传</div>
							</template>
						</el-table-column>
					</el-table>
                    <el-dialog  title="反映工程概况和质量状况的彩色照片15张" :visible.sync="dialogTableVisible" :center="true">
                        <div class="demo-image__lazy" v-if="parameters.SupplementaryContent">
                            <el-image v-for="item in parameters.SupplementaryContent.is20arr" :key="item['uid']" v-if="item.response&&item.response.data" :src="item.response.data.url" lazy></el-image>
                        </div>
                    </el-dialog>
				</el-tab-pane>
				<el-tab-pane label="申报汇总表需补充内容" name="seven">
					<div class="form_right">
						<div class="form_1">
							<div class="form_box_content">
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">承建单位工程技术负责人</div>
										<div class="form_content">
											{{parameters.DeclarationSummary.Technicaldirector}}
										</div>
										<div class="form_title" style="">参建单位工程技术负责人</div>
										<div class="form_long">
											{{parameters.DeclarationSummary.engineering}}
										</div>
										<div class="form_title" style="">建设单位主要负责人</div>
										<div class="form_long">
											{{parameters.DeclarationSummary.Construction_unit}}
										</div>
									</div>
								</div>
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">设计单位主要负责人</div>
										<div class="form_content">
											{{parameters.DeclarationSummary.Design_unit}}
										</div>
										<div class="form_title" style="">质量监督单位</div>
										<div class="form_long">
											{{parameters.DeclarationSummary.supervisionunit}}
										</div>
										<div class="form_title" style="">质量监督单位主要负责人</div>
										<div class="form_long">
											{{parameters.DeclarationSummary.Principaloftheunit}}
										</div>
									</div>
								</div>
								<div class="flex">
									<div class="my_form2">
										<div class="form_title" style="">监理单位总监工程师</div>
										<div class="form_content">
											<div class="input">
												{{parameters.DeclarationSummary.Chiefengineer}}
											</div>
										</div>
										<div class="form_title" style=""></div>
										<div class="form_content">
										</div>
										<div class="form_title" style=""></div>
										<div class="form_content">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
<!--				<el-tab-pane label="推荐表" name="eight">-->
<!--                    <el-table :data="temRecommandlist"-->
<!--                              :header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"-->
<!--                              style="width: 100%;" :cell-style="{'text-align':'center'}">-->
<!--                        <el-table-column prop="" label="序号" min-width="40">-->
<!--                            <template slot-scope="scope">-->
<!--                                <span v-text="getIndex(scope.$index)"> </span>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="资料名称" show-overflow-tooltip min-width="200">-->
<!--                            <template slot-scope="scope">-->
<!--                                <a class="a01" v-if="scope.row.is=='1'&&scope.row.filename!='反映工程概况和质量状况的彩色照片15张'" :href="scope.row.file.response.data.host+scope.row.file.response.data.url" target="_blank">{{scope.row.filename}}</a>-->
<!--                                <span v-else >{{scope.row.filename}}</span>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column min-width="100" label="是否已上传">-->
<!--                            <template slot-scope="scope">-->
<!--                                <div v-if="scope.row.is=='1'" style="line-height: 10px;height: 21px;">-->
<!--                                    <i style="color:#37C8AA;font-size: 20px;vertical-align: middle" class="el-icon-success"></i>-->
<!--                                    <span class="span02">已上传</span>-->
<!--                                </div>-->
<!--                                <div v-else class="span03">未上传</div>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                    </el-table>-->
<!--				</el-tab-pane>-->
				<el-tab-pane label="补充材料" name="nine">
                    <el-table :data="temSupplementlist"
                              :header-cell-style="{ background: '#F5F6F7', color: '#808895','text-align':'center'}"
                              style="width: 100%;" :cell-style="{'text-align':'center'}">
                        <el-table-column prop="" label="序号" min-width="40">
                            <template slot-scope="scope">
                                <span v-text="getIndex(scope.$index)"> </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="资料名称" show-overflow-tooltip min-width="200">
                            <template slot-scope="scope">
                                <a class="a01" :href="scope.row.url" target="_blank">{{scope.row.name}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" label="操作">
                            <template slot-scope="scope">
                                <a class="a01" :href="scope.row.url" target="_blank">查看详情</a>
                            </template>
                        </el-table-column>
                    </el-table>
				</el-tab-pane>
			</el-tabs>
			<div class="pform_title">评审日志</div>
			<el-table :data="checkedlogs"
				:header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center'}"
				style="width: 100%;" :cell-style="{'text-align':'center'}">
				<el-table-column prop="created_at" label="评审时间" min-width="80"></el-table-column>
				<el-table-column   prop="status" label="评审结果" min-width="80">
				    <template slot-scope="scope"> 
					     <span v-text="scope.row.status == 5 ? '驳回' : '通过' "> </span>
					</template>
					
				</el-table-column>
				<el-table-column prop="reject_reason" label="附言"
					max-width="250"></el-table-column>
			</el-table>
			
		</div>

		<!-- 工程建设质量管理小组竞赛活动  -->
		<group-award-detail
				v-if="step === '工程建设质量管理小组竞赛活动'"
				:model="curObj"
				:parameters="parameters"
				:table-data="temformlist"
				@pass="handleEdit"
				@reject="handleDelete"
				@assign="row => getapply(row)">
		</group-award-detail>

		<!-- 分配专家分组弹窗 -->
		<assign-zj-group-dialog
			:show.sync="isShowAssignGroup"
			:model="curObj"
			:re-assign="reAssign"
			@success="isShowAssignGroup=false;initList(1);getvalue();">
		</assign-zj-group-dialog>

        <el-dialog title="分配专家" :visible.sync="dialogZJVisible" width="774px">
            <div class="divZJ" :style="{height: scrollerHeight}">
                <el-checkbox-group v-model="zjId">
                    <el-checkbox v-for="(item,index) in zjlist" class="radio01" :label="item.id" border>{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogZJVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitZJ">确 定</el-button>
                  </span>
        </el-dialog>
        <el-dialog title="填写不通过原因" :visible.sync="dialogVisible" width="774px" :before-close="handleClose">
            <div class="yellow-box">
                <span>{{ user.legal_representative_id }}</span>
                <span>{{ user.name }}</span>
                <span>申请提交于{{ created_at }}</span>
            </div>
            <textarea class="reason" name="" id="" cols="30" rows="10" maxlength="500" v-model="reason"
                      placeholder="点击输入无法通过审核的原因..."></textarea>
            <span slot="footer" class="dialog-footer">
					<el-button type="primary" icon="el-icon-check" @click="sumbit">确认提交</el-button>
				</span>
        </el-dialog>
	</div>
</template>

<script>
	import AllHeader from "@/components/Modal/AllHeader";
	import Pagetion from "@/components/Modal/Pagetion";
	import groupAwardDetail from './applyAward/groupAwardDetail'
	import assignZjGroupDialog from './applyAward/assignZjGroupDialog'
	import {
		expertaward, //专家端审核奖项列表=
		expertverify, //专家端审核是否通过
        getExpert,
        setExpert,//设置专家
       AwardBatches
	} from "../utils/api.js";
	export default {
		components: {
			AllHeader,
			Pagetion,
			groupAwardDetail,
			assignZjGroupDialog
		},
		data() {
			return {
                loading:true,
                download:false,
				dialogVisible: false,
                dialogUnitVisible: false,
                dialogTableVisible:false,
                dialogZJVisible:false,
				step: 0,
                timeRange: '',
                exportType:1,
				ischage: false,
				lable: "材料列表",
				pageSize: 10,
				total: 0,
				awardList: [],
				sublabel: "返回列表",
				subtitle: "", //副标题
				formlist: [],
				temformlist: [],
				temUnitlist:[],//参加单位信息
				temFilelist:[],//申报登记表需补充内容
                temRecommandlist:[],//推荐表
                temSupplementlist:[],
                zjlist:[],
                zjId:[],
                unit:{},//参加单位信息
				user: {},
				id: '',
				reason: "",
				year: null,
				activeName: "first",
				parameters:{"Contractorinfo":{},"SupplementaryContent":{}},
                keyword:'',
                searchYear:'',
                searchstatus:'1',
                award_id:0,
				curObj: {}, // 当前点击的行
				isShowAssignGroup: false,
				reAssign: false,
                batches:[],
                checkedlogs:[],
                created_at:''
			};
		},
		mounted() {
			this.token = "Bearer " + localStorage.getItem("TOKEN");
			var zj_id = localStorage.getItem("zj_id");
			console.log("获取zjinfo",zj_id);
			if(zj_id){
				this.award_id = zj_id;
			}
			if(this.award_id == 17){
				this.searchstatus = '3';
			}
            this.getBatches();
			
		},
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 250) + 'px'; //自定义高度需求
            },
			isGroupAward() {
				return this.formlist.some(item => item.award_id === 17)
			}
        },
		methods: {
            async getBatches(){
                let res = await AwardBatches(this.award_id);
                console.log('res.data',res)
                this.batches = res;
                const currentBatchId = Number(this.$route.query.award_batch_id || 0);
                const hasCurrentBatch = this.batches.some(item => Number(item.id) === currentBatchId);
                this.searchYear = hasCurrentBatch ? currentBatchId : (this.batches.length ? this.batches[0]['id'] : '');
                this.initList(1);
            },
			//分页
			getIndex($index) {
			    return $index + 1;
			},
			getpageValue(index) {
				this.initList(index);
			},
            downloadClick(type){
                this.exportType = type;
                this.timeRange = '';
                this.download = true;
            },
            exportInfo(){
                 let url = `${window.location.protocol}//${window.location.host}/api/home/review/award_log/export/9?token=${this.token}`;
                 if (this.timeRange) {
                     url = url + '&start_time='+this.dateFormat(this.timeRange[0],'yyyy-MM-dd') + '&end_time=' + this.dateFormat(this.timeRange[1],'yyyy-MM-dd');
                 }
                 url += '&type='+this.exportType;
                 console.log(url)
                 window.open(url);
            },
            handleUnitClose(done) {
                done();
            },
			handleClose(done) {
				this.$confirm("确认关闭？")
					.then((_) => {
						done();
					})
					.catch((_) => {});
			},
			async initList(page) {
				const data = {
					pageSize: this.pageSize,
					page: page,
					award_id: this.award_id,
					status: this.searchstatus
				};
                if(this.searchYear){
                    data.year = this.searchYear;
                }
                if(this.keyword){
                    data.keyword = this.keyword;
                }
				let res = await expertaward(data);
                this.loading = false;
				this.formlist = res.data || [];
				this.formlist.forEach(e => {
					let year = e.created_at.slice(0, 4);
					e.year = e.award_batch.year+'-'+e.award_batch.batch;//(parseInt(year) - 1) + '-' + year;
                    if(e.award_id!=9||e.no==0){
                        e.no = e.id;
                    }
				})
				this.total = res.total;
                console.log(this.formlist);
			},
			getvalue() {
				this.step = 0;
				this.ischage = false;
				this.subtitle = "";
			},
			getapply(obj = {}, config = {}) {
                console.log(obj,'getapply');
				this.reAssign = config.reAssign || false
				if (obj.award && obj.award.title === '工程建设质量管理小组竞赛活动') {
					this.curObj = obj
					this.isShowAssignGroup = true
					return
				}
                this.dialogZJVisible = true;
                this.zjId = [];
                this.id = obj.id;
                getExpert().then(res => {
                    this.zjlist = res;
                })
			},
            submitZJ(){
              //提交庄家
                let data = {
                    expert_ids:this.zjId
                }
                if(this.zjId.length<=0){
                    this.$message.error('请选择专家');
                    return;
                }

                setExpert(this.id,data).then(res => {
                    this.$message({
                        message: "保存成功",
                        type: "success",
                    })
                    this.zjId = [];
                    this.dialogZJVisible = false;
                    this.initList(1);
                    this.getvalue();
                }).catch(error => {
					this.$message({
						message: error,
						type: "warning",
					})
				});
            },
			toDetail(obj) {
				console.log(obj)
                this.id = obj.id;
				this.parameters = obj.content
				const { award } = obj
				this.temformlist[0] = obj;
				this.ischage = true;
				this.curObj = obj
                this.temSupplementlist = [];
                this.checkedlogs = obj.checkedlogs;
                if(obj.file_urls != undefined){
                    if(obj.file_urls){
                        let arr = obj.file_urls.split('$$');
                        console.log('arr',arr);
                        for(let i=0,j=arr.length;i<j;i++){
                            let temArr = arr[i].split(',');
                            this.temSupplementlist.push({'name':temArr[0],'url':temArr[1]})
                        }
                    }
                }
                console.log('temSupplementlist',this.temSupplementlist);
				if (award.title === '工程建设质量管理小组竞赛活动') {
					this.step = '工程建设质量管理小组竞赛活动'
					return
				}
				this.temUnitlist = obj.content.unitinfo;

				let temFiles = obj.content.SupplementaryContent;
                console.log('temFiles',temFiles)
                this.temFilelist = [];
                if(temFiles != undefined){
                    var created_at = obj.created_at.substring(0,10).replace(/-/g,'');
                    console.log('created_at',created_at)
                    if( created_at < '20240925'){
                        if(temFiles.is1 != undefined){
                            this.temFilelist.push({"is":temFiles.is1,'file':temFiles.is1arr[0]?temFiles.is1arr[0]:{"response":{"data":{}}},'filename':'工程立项批复'});
                        }
                        if(temFiles.is2 != undefined){
                            this.temFilelist.push({"is":temFiles.is2,'file':temFiles.is2arr[0]?temFiles.is2arr[0]:{"response":{"data":{}}},'filename':'土地使用证'});
                        }
                        if(temFiles.is3 != undefined){
                            this.temFilelist.push({"is":temFiles.is3,'file':temFiles.is3arr[0]?temFiles.is3arr[0]:{"response":{"data":{}}},'filename':'建设工程规划许可证'});
                        }
                        if(temFiles.is4 != undefined){
                            this.temFilelist.push({"is":temFiles.is4,'file':temFiles.is4arr[0]?temFiles.is4arr[0]:{"response":{"data":{}}},'filename':'工程创优策划书'});
                        }
                        if(temFiles.is5 != undefined){
                            this.temFilelist.push({"is":temFiles.is5,'file':temFiles.is5arr[0]?temFiles.is5arr[0]:{"response":{"data":{}}},'filename':'工程施工图设计文件审查合格书或审批文件'});
                        }
                        if(temFiles.is6 != undefined){
                            this.temFilelist.push({"is":temFiles.is6,'file':temFiles.is6arr[0]?temFiles.is6arr[0]:{"response":{"data":{}}},'filename':'工程施工合同'});
                        }
                        if(temFiles.is7 != undefined){
                            this.temFilelist.push({"is":temFiles.is7,'file':temFiles.is7arr[0]?temFiles.is7arr[0]:{"response":{"data":{}}},'filename':'“施工许可证”或“批准开工许可报告”'});
                        }
                        if(temFiles.is8 != undefined){
                            this.temFilelist.push({"is":temFiles.is8,'file':temFiles.is8arr[0]?temFiles.is8arr[0]:{"response":{"data":{}}},'filename':'建设工程“消防验收意见书”'});
                        }
                        if(temFiles.is9 != undefined){
                            this.temFilelist.push({"is":temFiles.is9,'file':temFiles.is9arr[0]?temFiles.is9arr[0]:{"response":{"data":{}}},'filename':'工程“竣工验收报告”'});
                        }
                        if(temFiles.is10 != undefined){
                            this.temFilelist.push({"is":temFiles.is10,'file':temFiles.is10arr[0]?temFiles.is10arr[0]:{"response":{"data":{}}},'filename':'“投入使用时间和使用效果证明”'});
                        }
                        if(temFiles.is11 != undefined){
                            this.temFilelist.push({"is":temFiles.is11,'file':temFiles.is11arr[0]?temFiles.is11arr[0]:{"response":{"data":{}}},'filename':'“建筑业10项新技术应用证明”'});
                        }
                        if(temFiles.is12 != undefined){
                            this.temFilelist.push({"is":temFiles.is12,'file':temFiles.is12arr[0]?temFiles.is12arr[0]:{"response":{"data":{}}},'filename':'工业交通水利其“技术指标、经济效益及社会效益应达到本专业”'});
                        }
                        if(temFiles.is13 != undefined){
                            this.temFilelist.push({"is":temFiles.is13,'file':temFiles.is13arr[0]?temFiles.is13arr[0]:{"response":{"data":{}}},'filename':'建筑业新技术应用示范工程或绿色施工示范工程证书'});
                        }
                        if(temFiles.is14 != undefined){
                            this.temFilelist.push({"is":temFiles.is14,'file':temFiles.is14arr[0]?temFiles.is14arr[0]:{"response":{"data":{}}},'filename':'“贵州省建筑工程优质质量结构工程”评定文件'});
                        }
                        if(temFiles.is15 != undefined){
                            this.temFilelist.push({"is":temFiles.is15,'file':temFiles.is15arr[0]?temFiles.is15arr[0]:{"response":{"data":{}}},'filename':'“贵州省建筑安全文明施工样板工地”评定文件'});
                        }
                        if(temFiles.is16 != undefined){
                            this.temFilelist.push({"is":temFiles.is16,'file':temFiles.is16arr[0]?temFiles.is16arr[0]:{"response":{"data":{}}},'filename':'无质量安全事故承诺'});
                        }
                        if(temFiles.is18 != undefined){
                            this.temFilelist.push({"is":temFiles.is18,'file':temFiles.is18arr[0]?temFiles.is18arr[0]:{"response":{"data":{}}},'filename':'无拖欠农民工工资承诺'});
                        }
                    } else {
                        if(temFiles.is23 != undefined ){
                            this.temFilelist.push({"is":temFiles.is23,'file':temFiles.is23arr[0] ? temFiles.is23arr[0] :'' ,'filename':'“施工许可证”或“施工许可文件”'});
                        }
                        if(temFiles.is24 != undefined ){
                            this.temFilelist.push({"is":temFiles.is24,'file':temFiles.is24arr[0]? temFiles.is24arr[0] : '' ,'filename':'工程“创优”策划书'});
                        }
                        if(temFiles.is25 != undefined ){
                            this.temFilelist.push({"is":temFiles.is25,'file':temFiles.is25arr[0]? temFiles.is25arr[0] : '','filename':'1.建筑市政工程提交“竣工验收报告”；2.工业、交通工程提交“交工验收证书”或“静态验收报告（铁路工程）”；3.电力工程提交“竣工验收报告”；4.水利工程提交“工程合同完工验收文件”；'});
                        }
                        if(temFiles.is26 != undefined ){
                            this.temFilelist.push({"is":temFiles.is26,'file':temFiles.is26arr[0]? temFiles.is26arr[0]: '' ,'filename':'建设工程“消防验收意见书”（涉及消防工程）'});
                        }
                        if(temFiles.is27 != undefined ){
                            this.temFilelist.push({"is":temFiles.is27,'file':temFiles.is27arr[0]? temFiles.is27arr[0] : '' ,'filename':'“投入使用时间和使用效果证明”（建设单位出具）'});
                        }
                        if(temFiles.is28 != undefined ){
                            this.temFilelist.push({"is":temFiles.is28,'file':temFiles.is28arr[0]? temFiles.is28arr[0] :  '','filename':'“建筑业10项新技术应用证明”（监理单位出具）'});
                        }
                        if(temFiles.is29 != undefined ){
                            this.temFilelist.push({"is":temFiles.is29,'file':temFiles.is29arr[0]? temFiles.is29arr[0] : '' ,'filename':'工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平”证明（监理单位出具）'});
                        }
                        if(temFiles.is30 != undefined ){
                            this.temFilelist.push({"is":temFiles.is30,'file':temFiles.is30arr[0]? temFiles.is30arr[0] : '','filename':'住宅工程需提供入住率达到50％的证明（建设单位出具）'});
                        }
                        if(temFiles.is31 != undefined ){
                            this.temFilelist.push({"is":temFiles.is31,'file':temFiles.is31arr[0]? temFiles.is31arr[0] : '' ,'filename':'工程在施工过程中开展绿色施工并经评价合格'});
                        }
                        if(temFiles.is32 != undefined ){
                            this.temFilelist.push({"is":temFiles.is32,'file':temFiles.is32arr[0]? temFiles.is32arr[0]  : '','filename':'建筑工程提供省（部）级结构优或满足《建筑工程施工质量评价标准》GB／T50375优良评价报告（监理单位或有资质的检测单位出具）'});
                        }
                        if(temFiles.is33 != undefined ){
                            this.temFilelist.push({"is":temFiles.is33,'file':temFiles.is33arr[0]? temFiles.is33arr[0]  : '','filename':'无质量安全事故和无拖欠农民工工资承诺。（申报单位和参建单位都应提供）'});
                        }
                        if(temFiles.is34 != undefined ){
                            this.temFilelist.push({"is":temFiles.is34,'file':temFiles.is34arr[0]? temFiles.is34arr[0]  : '','filename':'贵州省优质工程申报汇总表（XLSX格式）'});
                        }
                        if(temFiles.is35 != undefined ){
                            this.temFilelist.push({"is":temFiles.is35,'file':temFiles.is35arr[0]?  temFiles.is35arr[0] : '','filename':'贵州省优质工程申报汇总表（盖章后扫描件PDF格式）'});
                        }
                    }


    				if(temFiles.is20 != undefined ){
                        this.temFilelist.push({"is":temFiles.is20,'file':temFiles.is20arr,'filename':'反映工程概况和质量状况的彩色照片15张'});
                    }
                    if(temFiles.is21 != undefined){
                        this.temFilelist.push({"is":temFiles.is21,'file':temFiles.is21arr[0]?temFiles.is21arr[0]:{"response":{"data":{}}},'filename':'5分钟影像或PPT资料'});
                    }
                    if(temFiles.is22 != undefined){
                        this.temFilelist.push({"is":temFiles.is22,'file':temFiles.is22arr[0]?temFiles.is22arr[0]:{"response":{"data":{}}},'filename':'贵州省优质工程申报表(盖章后扫描件)'});
                    }
                }


				//this.temFilelist.push({"is":temFiles.is17,'file':temFiles.is17arr[0]?temFiles.is17arr[0]:{"response":{"data":{}}},'filename':'无质量安全事故承诺补充材料'});

				//this.temFilelist.push({"is":temFiles.is19,'file':temFiles.is19arr[0]?temFiles.is19arr[0]:{"response":{"data":{}}},'filename':'无拖欠农民工工资承诺补充材料'});



                console.log('this.temFilelist',this.temFilelist)

                this.temRecommandlist = [];
                let recommendationform = obj.content.Recommendationform;
                if(recommendationform != undefined){
                     for(let i=0,j=recommendationform.length;i<j;i++){
                        this.temRecommandlist.push({'is':'1','file':recommendationform[i],'filename':'优质工程申报表'})
                    }
                }

                //this.temSupplementlist = [];
				this.step = 1;

			},
            toUnitDetail(obj){
                console.log(obj,'toUnitDetail')
                this.unit = obj;
                this.dialogUnitVisible = true;
            },
			//通过
			handleEdit(a, b) {
				console.log(a, b);
				let data = {
					status: 4
				}
                this.$confirm("确认通过？")
                    .then((_) => {
                        expertverify(data, b.id).then(res => {
                            this.$message({
                                message: "审核成功",
                                type: "success",
                            })
                            this.initList(1);
                            this.getvalue();
                        }).catch(error => {
                            this.$message({
                                message: error,
                                type: "warning",
                            })
                        })
                    })
                    .catch((_) => {});
			},
			//立即提交
			sumbit() {
				if (this.reason == "") {
					this.$message.error('请填写不通过原因')
					return false
				}
				let data = {
					status: 5,
                    reject_reason: this.reason
				}
				expertverify(data, this.id).then(res => {
					this.$message({
						message: "提交成功",
						type: "success",
					})
                    this.reason = '';
                    this.dialogVisible = false;
                    this.initList(1);
                    this.getvalue();
				}).catch(error => {
                    this.dialogVisible = false;
					this.$message({
						message: error,
						type: "warning",
					})
                    this.reason = '';
				})
			},
			//不予通过
			handleDelete(a, b) {
				this.dialogVisible = true;
				this.user = b.user
				this.id = b.id
				this.created_at = b.created_at;
			},
            resetQuery() {
                this.searchYear = '';
                this.keyword = '';
                this.award_id = 0;
                this.loading = true;
                this.initList(1);
            },
            handleQuery(){
                this.loading = true;
                this.initList(1);
            },
            dateFormat(date,fmt) {
                let ret
                const opt = {
                    'y+': date.getFullYear().toString(), // 年
                    'M+': (date.getMonth() + 1).toString(), // 月
                    'd+': date.getDate().toString(), // 日
                    'H+': date.getHours().toString(), // 时
                    'm+': date.getMinutes().toString(), // 分
                    's+': date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                }
                for (let k in opt) {
                    ret = new RegExp('(' + k + ')').exec(fmt)
                    if (ret) {
                        fmt = fmt.replace(
                            ret[1],
                            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
                        )
                    }
                }
                return fmt
            },
			viewRejectReason(row) {
				this.$alert(row.reject_reason, '驳回理由', {
					confirmButtonText: '确定'
				});
			}
		},
	};
</script>

<style>
	.el-tabs__header {
		width: 100% !important;
	}
    .divZJ{
        text-align: left;overflow:auto;
    }
</style>
<style lang="less" scoped>
	/deep/.block-title {
		border-left: 3px solid #194abe !important;
	}

	.yellow-box {
		height: 40px;
		background: #FEF8EF;
		opacity: 1;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;

		span {
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			line-height: 24px;

			&:nth-child(1) {
				color: #194ABE;
			}

			&:nth-child(2) {
				color: #0C0D0F;
			}

			&:nth-child(3) {
				color: #7C828A;
				font-size: 14px;
			}
		}
	}

	.reason {
		margin-top: 20px;
		width: 100%;
		height: 162px;
		background: #FFFFFF;
		border: 1px solid #BDC3CB;
		opacity: 1;
		border-radius: 4px;
		outline: none;
		padding: 10px;
		box-sizing: border-box;
	}

	.textarea {
		width: 382px;
		// height: 92px;
		background: #ffffff;
		border: 1px solid #bdc3cb;
		opacity: 1;
		border-radius: 4px;
	}

	.block-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin: 20px 0;

		&-item {
			width: 370px;
			background: #ffffff;
			border: 1px dashed #c8cdd5;
			padding: 24px 25px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-bottom: 21px;
			position: relative;

			&-r-t {
				position: absolute;
				top: 0;
				right: 0;
				width: 73px;
				height: 27px;
				background: #f5f9fb;
				opacity: 1;
				border-radius: 0px 0px 0px 80px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				line-height: 27px;
				color: #c6c9ce;
				padding-left: 10px;
				box-sizing: border-box;
			}

			&-box {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				align-items: flex-start;

				&-t {
					width: 244px;
					color: #0c0d0f;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-align: justify;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
				}

				&-dtae {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					line-height: 26px;
					color: #194abe;
				}

				&-startend {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					line-height: 26px;
					color: #7c828a;
				}

				&-b {
					width: 91px;
					height: 32px;
					background: #ffffff;
					border: 1px solid #194abe;
					color: #194abe;
					opacity: 1;
					border-radius: 6px;
					text-align: center;
					line-height: 32px;
					font-size: 14px;
					cursor: pointer;
				}

				&-b-d {
					background: #ffffff !important;
					border: 1px solid #d4dbdd !important;
					color: #c8cdd5 !important;
				}

				&-b-s {
					background: #d4dbdd !important;
					border: 1px solid #d4dbdd !important;
					color: #ffffff !important;
				}
			}
		}
	}

	.margin-bottom-40 {
		margin-bottom: 40px;
	}

	.infor {
		padding-bottom: 40px;
		min-height: 800px;
		margin-bottom: 34px;
		position: relative;
	}

	.upload-demo {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	.uploadheader {
		height: 60px;
		width: 100%;
		display: flex;
		align-items: center;

		span {
			margin-right: 10px;
			color: #71767c;
		}
	}

	.margin-top-40 {
		margin-top: 40px;
	}

	.block-solid {
		width: 100%;
		height: 2px;
		background-color: #e51725;
		margin-top: 30px;
	}

	.shenhjrkr {
		margin: 71px 0 100px 0;

		img {
			width: 120px;
		}
	}
	.block-addr {
		display: inline-block;
		padding: 13px 32px;
		background-color: #fff7e8;
		font-size: 14px;
		margin-top: 31px;

		.span-l {
			color: #9fa5ae;
		}

		.span-r {
			color: #194abe;
		}
	}
	.pform_title {
	    font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 700;
        line-height: 20px;
        color: #0c0d0f;
        text-align: left;
	}
	.form_right {
	      width: 860px;
	      .flex {
	        display: flex;
	      }
	      .flex-direction {
	        flex-direction: column;
	      }
	      .form_1 {
	        width: 100%;
	        background: #ffffff;
	        padding: 35px 30px;
	        box-sizing: border-box;
	        margin-bottom: 30px;
	        border-radius: 6px;

			.form_dec {
				text-align: left;
				margin-top: 20px;
			}

	        .border {
	          border-top: 1px dashed #9fa5ae;
	          margin: 20px 0;
	        }
	        .bord {
	          margin-top: 11px;
	          width: 858px;
	          height: 0px;
	          border: 1px solid #194abe;
	          position: relative;
	          img {
	            width: 11px;
	            height: 6px;
	            position: absolute;
	            top: -6px;
	            left: 37px;
	          }
	        }
	        .newlybuild {
	          margin: 0 auto;
	          cursor: pointer;
	          width: 221px;
	          height: 36px;
	          border: 2px solid #194abe;
	          border-radius: 4px;
	          display: flex;
	          justify-content: center;
	          align-items: center;
	          img {
	            width: 16px;
	            height: 16px;
	            margin-right: 7px;
	          }
	          p {
	            font-size: 14px;
	            font-family: Microsoft YaHei;
	            font-weight: 400;
	            line-height: 14px;
	            color: #194abe;
	          }
	        }
	        .form_box_content {
	          width: 100%;
	          .form_title {
	            box-sizing: border-box;
	            text-align: start;
	            display: flex;
	            p {
	              font-size: 16px;
	              font-family: Microsoft YaHei;
	              font-weight: bold;
	              line-height: 20px;
	              color: #0c0d0f;
	            }
	            .delete_icon {
	              cursor: pointer;
	              margin-left: 10px;
	              width: 61px;
	              height: 25px;
	              background: #ffffff;
	              border: 1px solid #f9656f;
	              opacity: 1;
	              border-radius: 6px;
	              display: flex;
	              align-items: center;
	              justify-content: space-evenly;
	              img {
	                width: 13px;
	                height: 14px;
	              }
	              p {
	                font-size: 14px;
	                font-family: Source Han Sans CN;
	                font-weight: 400;
	                line-height: 20px;
	                color: #f9656f;
	              }
	            }
	          }
	        }
	      }
	    }

	.flex {
	    display: flex;
	    align-items: center;
	  }
	  .my_form,
	  .my_form2 {
	    width: 100%;
	    height: 100%;
	    display: flex;
	    overflow: visible;
	    align-items: stretch;
		margin-bottom: 30px;
	    .form_title {
	      width: 80px;
	      min-width: 80px;
	      height: auto;
	      display: flex;
	      justify-content: left;
	      font-size: 14px;
	      font-family: Microsoft YaHei;
	      font-weight: 400;
	      line-height: 20px;
	      box-sizing: border-box;
	      color: #808895;
	    }
	    .form_content,
	    .form_long,
	    .form_content {
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		  width:230px;
	    }
		.form_textarea{
			color:#323232;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			font-size: 14px;
	      position: relative;
		  padding-right: 6px;
		  text-align:left;
		}
	  }
      .a01{
          color:#000;
      }
      .a01:hover{
          color:#194ABE;
          text-decoration:underline;
      }
      .a01:visited{
          color:#000;
      }
      .span02{
          font-weight: 400;
          color: #37C8AA;
          margin-left: 5px;
      }
      .span03{
          color: #B0B6C1;
          font-weight: 400;
      }
	  .spanText{
		  margin-top:25px;
		  font-size: 16px;
		  font-family: PingFang SC-Semibold, PingFang SC;
		  font-weight: 600;
		  color: #194ABE;
		  line-height: 0px;
		  -webkit-background-clip: text;
	  }
      .radio01{
          background:#F5F6F7;
          margin-bottom:15px;
          border: none !important;
          width:100px;
          margin-left: 10px;
          margin-right: 10px;
          white-space: nowrap;
          display: inline-block;
          overflow: hidden;
      }
      .pos-page {
      	position: absolute;
      	bottom: 0px !important;
      	width: 100%;
      }

      .infor {
          width: 1050px !important;
      }
      .w-1200 {
          width: 1500px  !important;
          margin: 0 auto;
      }
</style>
